<template>
  <section class="home">
    <div class="header gap-30 flex-col">
      <div class="row jc-between">
        <SectionTitle title="Manutenzione" :subtitle="monitorings.data.length + ' monitoraggi visibili'" icon="helmet"
          :border="true" />
        <div class="searchbox flex-col ai-end">
          <VInput type="text" :icon="require('@/assets/icons/search.svg')" :iconSize="15" v-model="searchQuery"
            @input="search" />
          <!-- <b>Ricerca Avanzata</b> -->
        </div>
      </div>

      <div class="row jc-between">
        <DropDown class="view" :options="monitoringTypes" :selected="selectedMonitoringType"
          @select="selectMonitoringType" label="Monitoraggio" />
        <VButton class="gap-10" @click="uiState.popup = true; uxStore.showOverlay = true" label="Aggiungi Nuovo"
          :icon="require('@/assets/icons/add.svg')" :reverse="true" />
      </div>

      <div class="row flex-col jc-between gap-10">
        <div class="row gap-10 inner-row">
          <DropDown :options="MONITORING_TIME_FILTERS" :selected="selectedTimeRange" @select="filterByCreationDate"
            :label="selectedTimeRange ? selectedTimeRange : 'Data'" />
          <DropDown :options="topographicElementsTypes" @select="filterByTe4Type"
            :selected="selectedTopographicElement4Type"
            :label="selectedTopographicElement4Type ? selectedTopographicElement4Type : 'Referente topografico'" />
          <DropDown :options="users" @select="filterByCompiler" :selected="selectedCompiler"
            :label="selectedCompiler ? selectedCompiler : 'Operatore'" />
          <DropDown :options="projects" @select="filterByProject" :selected="selectedProject"
            :label="selectedProject ? selectedProject : 'Progetto'" />
        </div>

        <div class="row filters jc-between ai-center gap-10 inner-row" v-show="selectedMonitoringType === 'punctual'">
          <div class="radio-buttons flex-row gap-10">
            <VIcon :src="require('@/assets/icons/filter.svg')" />
            <span>Filtra per: indici</span>
            <div class="gap-20">
              <RadioButton v-model="punctualMonitoringFilters.type" label="IA" value="ia" />
              <RadioButton v-model="punctualMonitoringFilters.type" label="IFR" value="ifr" />
            </div>
          </div>
          <div>
            <ColorCheckbox v-model="punctualMonitoringFilters.level[1]" boxColor="var(--bassa-color)" label="b" />
            <ColorCheckbox v-model="punctualMonitoringFilters.level[2]" boxColor="var(--media-bassa-color)"
              label="m-b" />
            <ColorCheckbox v-model="punctualMonitoringFilters.level[3]" boxColor="var(--media-color)" label="m" />
            <ColorCheckbox v-model="punctualMonitoringFilters.level[4]" boxColor="var(--media-alta-color)" label="m-a"
              :value="1" />
            <ColorCheckbox v-model="punctualMonitoringFilters.level[5]" boxColor="var(--alta-color)" label="a"
              :value="0" />
          </div>
        </div>

        <hr />

        <!-- Header custom identico (continui a usare ColumnSort) -->
        <div class="grid sort-filters gap-20">
          <span></span>
          <ColumnSort label="Data" @sort="sort" name="date" ref="dateSort" @interface="getDateSortInterface" />
          <ColumnSort label="Progetto" @sort="sort" name="project" ref="projectSort"
            @interface="getProjectSortInterface" />
          <ColumnSort label="Operatore" @sort="sort" name="compiler" ref="compilerSort"
            @interface="getCompilerSortInterface" />
          <ColumnSort label="Ref. topografico" @sort="sort" name="topographicElement" ref="topographicElementSort"
            @interface="getTopographicReferenceSortInterface" />
          <ColumnSort label="Validazione" @sort="sort" name="validationElement" ref="validationElementSort"
            @interface="getValidationReferenceSortInterface" />
        </div>
      </div>
    </div>

    <!-- LISTA: ora è AG Grid -->
    <div class="list flex-col gap-5" ref="itemList" id="itemList">
      <AgGridVue class="ag-theme-alpine visiva-grid" domLayout="autoHeight" :rowData="gridRowData"
        :columnDefs="columnDefs" :defaultColDef="defaultColDef" :components="components" :getRowId="getRowId"
        :headerHeight="0" :suppressHorizontalScroll="true" :suppressRowClickSelection="true" :suppressCellFocus="true"
        :suppressMovableColumns="true" :rowSelection="'single'" :suppressNoRowsOverlay="true"
        :suppressScrollOnNewData="true" @grid-ready="onGridReady" />

      <VLottie class="loading" v-if="loading" ref="animation" :src="require('@/assets/icons/loading.json')"
        :autoplay="true" :loop="true" />

      <div class="no-results" v-if="!loading && monitorings.data.length === 0">
        <span>Nessun risultato</span>
      </div>
    </div>

    <Transition name="aggiungi" appear>
      <AddNewPopUp v-if="uiState.popup" @select="openForm" v-on-click-outside="() => { uiState.popup = false }"
        @close="uiState.popup = false" />
    </Transition>
  </section>
</template>

<script>
import DropDown from '@/components/DropDown.vue'
import ColorCheckbox from '@/components/ColorCheckbox.vue'
import RadioButton from '@/components/RadioButton.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import AddNewPopUp from '@/components/AddNewPopUp.vue'
import ColumnSort from '@/components/ColumnSort.vue'

/** AG GRID */
import { AgGridVue } from 'ag-grid-vue3'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'

import { ref, onMounted, reactive, onActivated, onBeforeUnmount, onDeactivated } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

import { vOnClickOutside } from '@vueuse/components'
import { useUXStore } from '@/stores/ux'
import { MONITORING_TIME_FILTERS } from '@/utils/constants'

import { useHomeAgGrid } from '@/views/home/composables/useHomeAgGrid'
import { useHomeMonitorings } from '@/views/home/composables/useHomeMonitorings'
import { useHomeScrollPosition } from '@/views/home/composables/useHomeScrollPosition'
import { usePreventPullToRefresh } from '@/views/home/composables/usePreventPullToRefresh'

export default {
  name: 'HomeView',
  directives: {
    onClickOutside: vOnClickOutside
  },
  components: {
    DropDown,
    ColorCheckbox,
    SectionTitle,
    AddNewPopUp,
    ColumnSort,
    RadioButton,
    AgGridVue
  },
  setup() {
    const uxStore = useUXStore()
    const router = useRouter()
    const authStore = useAuthStore()

    const itemList = ref(null)
    const uiState = reactive({ popup: false })

    const sortInterfaces = reactive({
      date: null,
      project: null,
      compiler: null,
      topographicReference: null,
      validationReference: null
    })

    const getDateSortInterface = (sortInterface) => {
      sortInterfaces.date = sortInterface
    }

    const getProjectSortInterface = (sortInterface) => {
      sortInterfaces.project = sortInterface
    }

    const getCompilerSortInterface = (sortInterface) => {
      sortInterfaces.compiler = sortInterface
    }

    const getTopographicReferenceSortInterface = (sortInterface) => {
      sortInterfaces.topographicReference = sortInterface
    }

    const getValidationReferenceSortInterface = (sortInterface) => {
      sortInterfaces.validationReference = sortInterface
    }

    const showElement = (item) => {
      const route = {
        name:
          'mostra-monitoraggio-' +
          (item.monitoring_type === 'quick'
            ? 'speditivo'
            : item.monitoring_type === 'punctual'
              ? 'puntuale'
              : 'orizzontale'),
        params: {
          id:
            item.monitoring_type === 'quick'
              ? item['quickMonitoringId']
              : item.monitoring_type === 'punctual'
                ? item['punctualMonitoringId']
                : item['horizontalMonitoringId']
        }
      }

      if (authStore?.user?.admin === 1) {
        const href = router.resolve(route).href
        const tab = window.open(href, '_blank')
        if (!tab) router.push(route)
        return
      }

      router.push(route)
    }

    const editElement = (item) => {
      let route = null

      switch (item.monitoring_type) {
        case 'quick':
          route = {
            name: 'monitoraggio-speditivo',
            params: { id: item.quick_monitoring.id }
          }
          break
        case 'punctual':
          route = {
            name: 'monitoraggio-puntuale',
            params: { id: item['punctualMonitoringId'] }
          }
          break
        case 'horizontal':
          route = {
            name: 'monitoraggio-orizzontale',
            params: { id: item['horizontalMonitoringId'] }
          }
          break
        default:
          return
      }

      if (authStore?.user?.admin === 1) {
        const href = router.resolve(route).href
        const tab = window.open(href, '_blank')
        if (!tab) router.push(route)
        return
      }

      router.push(route)
    }

    const linkElement = (item) => {
      uxStore.rightMenu.data.polygons.forEach(polygon => {
        polygon.focus =
          item.topographic_element4 &&
          polygon.topographic_element_id === item.topographic_element_4_id
      })
    }

    const monitorings = reactive({ data: [] })

    // Tipologie di monitoraggio
    const monitoringTypes = reactive([
      { label: 'Tipo di monitoraggio', icon: 'tutti.svg', value: null },
      { label: 'Orizzontale', icon: 'horizontal.svg', value: 'horizontal' },
      { label: 'Puntuale', icon: 'punctual.svg', value: 'punctual' }
    ])

    const {
      savedScrollPosition,
      attachScrollListener,
      detachScrollListener,
      restoreScroll,
    } = useHomeScrollPosition(itemList)

    const {
      gridRowData,
      columnDefs,
      defaultColDef,
      components,
      getRowId,
      onGridReady,
      closeExpanded,
      afterDataUpdate,
      cleanupGrid,
    } = useHomeAgGrid({
      monitorings,
      onShow: showElement,
      onEdit: editElement,
      onLink: linkElement,
    })

    const {
      loading,
      pageCounter,
      changedFilter,
      topographicElementsTypes,
      users,
      projects,
      selectedTopographicElement4Type,
      selectedMonitoringType,
      selectedTimeRange,
      selectedCompiler,
      selectedProject,
      orderBy,
      searchQuery,
      punctualMonitoringFilters,
      updateMonitorings,
      refreshAllPages,
      filterByTe4Type,
      filterByCompiler,
      filterByProject,
      filterByCreationDate,
      selectMonitoringType,
      clearMonitorings,
      search,
    } = useHomeMonitorings({
      uxStore,
      itemList,
      monitorings,
      closeExpanded,
      afterDataUpdate,
    })

    const { attach: attachPullToRefresh, detach: detachPullToRefresh } = usePreventPullToRefresh({
      onRefresh: clearMonitorings,
    })

    const detachListeners = () => {
      detachPullToRefresh()
      detachScrollListener()
      cleanupGrid()
    }

    const openForm = (value) => {
      uiState.popup = false
      uiState[value] = true
      uxStore.rightMenu.show = false

      switch (value) {
        case 'punctualMonitoringForm':
          router.push({ name: 'nuovo-monitoraggio-puntuale' })
          break
        case 'quickMonitoringForm':
          router.push({ name: 'nuovo-monitoraggio-speditivo' })
          break
        case 'horizontalMonitoringForm':
          router.push({ name: 'nuovo-monitoraggio-orizzontale' })
          break
      }
    }

    const closeForm = () => {
      uxStore.rightMenu.show = true
    }

    const sort = (field, direction) => {
      changedFilter.value = true

      switch (field) {
        case 'date':
          sortInterfaces.project?.reset?.()
          sortInterfaces.topographicReference?.reset?.()
          sortInterfaces.compiler?.reset?.()
          sortInterfaces.validationReference?.reset?.()
          break
        case 'project':
          sortInterfaces.date?.reset?.()
          sortInterfaces.topographicReference?.reset?.()
          sortInterfaces.compiler?.reset?.()
          sortInterfaces.validationReference?.reset?.()
          break
        case 'compiler':
          sortInterfaces.date?.reset?.()
          sortInterfaces.project?.reset?.()
          sortInterfaces.topographicReference?.reset?.()
          sortInterfaces.validationReference?.reset?.()
          break
        case 'topographicElement':
          sortInterfaces.date?.reset?.()
          sortInterfaces.project?.reset?.()
          sortInterfaces.compiler?.reset?.()
          sortInterfaces.validationReference?.reset?.()
          break
        case 'validationElement':
          sortInterfaces.date?.reset?.()
          sortInterfaces.project?.reset?.()
          sortInterfaces.compiler?.reset?.()
          sortInterfaces.topographicReference?.reset?.()
          break
        default:
          break
      }

      orderBy.value = { field, direction }
      if (orderBy.value.direction === 'none') orderBy.value = null

      updateMonitorings()
    }

    onMounted(() => {
      attachPullToRefresh()

      setTimeout(() => {
        attachScrollListener()
      }, 1000)
    })

    onBeforeUnmount(detachListeners)
    onDeactivated(detachListeners)

    onActivated(() => {
      refreshAllPages()
      restoreScroll()
      attachScrollListener()
    })

    return {
      // data
      monitorings,
      loading,
      uiState,
      itemList,
      pageCounter,
      changedFilter,
      savedScrollPosition,
      topographicElementsTypes,
      selectedTopographicElement4Type,
      MONITORING_TIME_FILTERS,
      users,
      projects,
      selectedProject,
      selectedCompiler,
      selectedMonitoringType,
      selectedTimeRange,
      orderBy,
      searchQuery,
      punctualMonitoringFilters,
      monitoringTypes,

      // store
      uxStore,
      router,
      authStore,

      // methods
      updateMonitorings,
      refreshAllPages,
      filterByTe4Type,
      filterByCompiler,
      filterByProject,
      filterByCreationDate,
      selectMonitoringType,
      search,
      openForm,
      closeForm,
      showElement,
      editElement,
      linkElement,
      sort,
      getDateSortInterface,
      getProjectSortInterface,
      getCompilerSortInterface,
      getTopographicReferenceSortInterface,
      getValidationReferenceSortInterface,

      // AG Grid bindings
      gridRowData,
      columnDefs,
      defaultColDef,
      components,
      getRowId,
      onGridReady
    }
  }
}
</script>

<style>
.home {
  flex-direction: column;
  width: 100%;
  margin: 30px;
  font-size: 13px;
  color: var(--secondary-color);
  --icon-color: var(--secondary-color);
}

.home * {
  color: var(--secondary-color);
}

.row span {
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.inner-row:last-child {
  margin: 10px 0 20px 0;
}

.home .color-checkbox {
  margin: 0 10px;
}

.searchbox {
  width: 50%;
  min-width: 200px;
  max-width: 400px;
}

.searchbox .v-input {
  border: 1px solid black;
  border-radius: 40px;
  height: 30px;
  padding: 1px 10px;
  width: 100%;
  font-size: 0.8125rem;
}

.searchbox b {
  text-decoration: underline;
  padding-top: 5px;
}

.sort-filters {
  grid-template-columns: 30px 90px 1fr 0.5fr 0.6fr 110px 1fr;
  text-align: left;
  padding: 0 20px;
}

.header .color-checkbox {
  height: 15px;
}

.list {
  height: 100%;
  overflow-y: auto;
  flex: 1;
  width: calc(100% + 15px);
  padding-right: 10px;
}

.dropdown.view .selected,
.dropdown.view .category .box {
  background-color: var(--base-light-color);
  --icon-color: var(--secondary-color);
}

.dropdown.view .category .box:hover {
  background-color: #dedede;
}

.dropdown:not(.view) p {
  color: var(--primary-color);
}

@media only screen and (max-height: 672px) {
  .home {
    margin: 20px 25px 0px 25px;
  }

  .home .header {
    gap: 10px;
  }

  .inner-row:last-child {
    margin: 5px 0 10px 0;
  }
}

.no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  font-size: 1.5rem;
  color: var(--secondary-color);
}

.home .filters .radiobutton {
  height: 15px;
  font-weight: 500;
}

.home .filters .radiobutton .v-lottie {
  border: 1px solid black;
  border-radius: 50%;
}

/* ===========================
   AG GRID: reset stile (così vedi SOLO il tuo stile “ItemList”)
   =========================== */
.home .visiva-grid {
  display: block;
  width: 100%;
  min-width: 0;

  /* Disabilita colori di hover/selection del tema Alpine */
  --ag-row-hover-color: transparent;
  --ag-selected-row-background-color: transparent;
  --ag-range-selection-background-color: transparent;
  --ag-range-selection-border-color: transparent;
}

/* niente header grid (hai già il tuo header con ColumnSort) */
.home .visiva-grid .ag-header {
  display: none !important;
}

.home .visiva-grid .ag-root-wrapper,
.home .visiva-grid .ag-root-wrapper-body,
.home .visiva-grid .ag-root {
  border: none !important;
  background: transparent !important;
}

.home .visiva-grid .ag-row,
.home .visiva-grid .ag-row-hover,
.home .visiva-grid .ag-row-selected {
  background: transparent !important;
}

/* alcuni temi applicano hover/selection sulle celle, non sulla riga */
.home .visiva-grid .ag-row-hover .ag-cell,
.home .visiva-grid .ag-row-selected .ag-cell,
.home .visiva-grid .ag-row-hover.ag-row-selected .ag-cell {
  background: transparent !important;
}

/* alpine usa anche overlay su pseudo-elementi */
.home .visiva-grid .ag-row-hover::before,
.home .visiva-grid .ag-row-selected::before,
.home .visiva-grid .ag-row-hover.ag-row-selected::before {
  background-color: transparent !important;
  opacity: 0 !important;
}

.home .visiva-grid .ag-cell {
  padding: 0 !important;
  border: none !important;
}

.home .visiva-grid .ag-cell:focus,
.home .visiva-grid .ag-cell-focus {
  outline: none !important;
  border: none !important;
}
</style>
